import { Component } from '@angular/core';
import { BaseCardComponent } from '../base-card/base-card.component';

@Component({
    selector: 'lib-small-card',
    templateUrl: './small-card.component.html',
    styleUrls: ['./small-card.component.scss'],
    standalone: false
})
export class SmallCardComponent extends BaseCardComponent {

}
